export class DashboardData {
  public tickets: number; // All tickets
  public active_tickets: number;
  public inactive_tickets: number;
  public fake_tickets: number;
  public flagged_requests: number;
  public admin_tickets: number;
  public popular_locations: string[];
  public seasons: number[];

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/model/dashboard-data.ts